import styled from '@emotion/styled';

export const SettingWrapper = styled.div`
  display: flex;
  min-width: 1000px;
  align-items: center;
  background: #fff;
  padding: 20px 40px;
  margin-top: 10px;
  &:first-of-type {
    margin-top: 18px;
  }
  & > strong {
    position: relative;
    display: block;
    width: 200px;
    height: 24px;
    font-size: 16px;
    line-height: 23px;
  }
`;

export const SettingBox = styled.div`
  position: relative;
  width: calc(100% - 232px);
  margin-left: 32px;
  &:before {
    content: '';
    display: block;
    width: 1px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: -32px;
    background: #e0e0e0;
  }
`;

export const SettingList = styled.ul`
  position: relative;

  & > li {
    display: flex;
    white-space: nowrap;
    align-items: center;
    margin-top: 28px;
    font-size: 14px;
    color: #333;
    & > div {
      + span {
        margin-left: 20px;
      }
    }
    & > strong {
      margin-right: 30px;
    }
    & > span {
      + div {
        width: 200px;
      }
    }
    &:first-of-type {
      margin-top: 0;
    }
    & .label-identicalInput {
      width: 60px;
      margin-right: 30px;
    }
    & .label-satisfied {
      margin-right: 12px;
      font-size: 14px;
      color: #555 !important;
    }
    & .identicalInput {
      width: 100px;
      & + .label-identicalInput {
        margin-left: 50px;
      }
    }
    & .second {
      margin-left: 10px;
    }
    & .guide-text {
      margin-left: 10px;
      font-size: 10px;
      color: #b6b6b6;
    }

    & .simple-deleted-caution {
      margin-top: -10px;
      color: #fa8282;
    }

    & .deleted-caution {
      margin-top: -30px;
      margin-left: 34px;
      color: #fa8282;
    }
  }

  /* identical series check */
  &.identical {
    & li {
      flex-flow: wrap;
      & .guide-text {
        margin: 8px 0 0 0;
      }
      & .last {
        margin-right: 30px;
      }
    }
  }

  & .delete-period {
    width: 130px;
    margin-right: -10px;
  }
`;

export const InputList = styled.ul`
  position: relative;
  display: flex;
  align-items: center;

  & li {
    margin-right: 40px;
    & .has-example {
      & div {
        margin-top: 14px;
      }
    }
    & > .example-format {
      display: block;
      margin-top: -6px;
      margin-left: 35px;
      font-size: 12px;
      color: #dbdbdb;
    }
  }
`;

export const SelectBox = styled.div`
  min-width: 84px;
  margin: 0 10px;
  & div {
    border-radius: 4px;
  }
`;

export const StyledSlice = styled.div`
  display: flex;
  align-items: center;
  width: auto !important;
  & + .slice {
    margin-left: 30px;
    margin-right: 30px;
  }
`;
